export const TRANSACTION_TYPES = {
  WRITE_OFF: "WRITE_OFF",
  REPLENISHMENT: "REPLENISHMENT",
}
